import { useMemo } from 'react';
import useAuth from 'src/hooks/useAuth';
import useGetSuperAdminsQuery from 'src/services/client/useGetSuperAdminsQuery';
import { isSuperAdminSession } from 'src/utils/authImpersonation';

/**
 * True when the current session should be treated as Super Admin:
 * JWT has IsSuperAdmin, or LoggedInCompanyId is in GET /api/Client/GetSuperAdmins
 * (covers impersonation, when the impersonated token's isSuperAdmin is false).
 */
const useIsSuperAdminSession = (): boolean => {
  const { isSuperAdmin, loggedInCompanyId } = useAuth();
  const { data: superAdminsData } = useGetSuperAdminsQuery();
  const superAdminCompanyIds = useMemo(
    () => superAdminsData?.map((sa) => sa.companyId) ?? [],
    [superAdminsData]
  );

  return useMemo(
    () => isSuperAdminSession(isSuperAdmin, loggedInCompanyId, superAdminCompanyIds),
    [isSuperAdmin, loggedInCompanyId, superAdminCompanyIds]
  );
};

export default useIsSuperAdminSession;
